import React from "react";

interface CaptionInputControlsProps {
  newCaption: string;
  onCaptionChange: (text: string) => void;
  onAddCaption: () => void;
}

const CaptionInputControls: React.FC<CaptionInputControlsProps> = ({
  newCaption,
  onCaptionChange,
  onAddCaption,
}) => {
  return (
    <div className="mb-6 p-4 bg-gray-50 rounded-lg">
      <div className="flex flex-row w-full justify-center">
        <span className="text-sm text-gray-500 mb-2 pb-2 ">
          טקסט שיופיע מעל התמונה עם רקע לבן
        </span>
      </div>
      <div className="flex flex-col sm:flex-row-reverse gap-4">
        <input
          type="text"
          value={newCaption}
          onChange={(e) => onCaptionChange(e.target.value)}
          placeholder="הכנס כיתוב כאן..."
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-pink-500 focus:border-transparent text-center"
          dir="rtl"
        />
        <button
          onClick={onAddCaption}
          className="px-4 sm:px-6 lg:px-8 py-2 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-lg hover:from-blue-600 hover:to-blue-700 transition-all duration-200 transform hover:scale-105 font-medium whitespace-nowrap text-sm sm:text-base"
        >
          הוסף כיתוב
        </button>
      </div>
    </div>
  );
};

export default CaptionInputControls;
